module.exports = "/images/vendor/flag-icon-css/flags/4x3/tn.svg?50cd91018d742d2f5c31a158d417ea87";